import { render, staticRenderFns } from "./appTrailerUploader.vue?vue&type=template&id=531041a2"
import script from "./appTrailerUploader.vue?vue&type=script&lang=js"
export * from "./appTrailerUploader.vue?vue&type=script&lang=js"
import style0 from "./appTrailerUploader.vue?vue&type=style&index=0&id=531041a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports